import { MachineConnectionType, TeamRole } from '../../api/graphql/generated';

export interface DirectConnectMachine {
  id: string;
  name: string;
  serialNumber: string;
  teamId: string;
}

export enum DirectConnectTaskType {
  DEACTIVATE = 'deactivate',
  PROVISION = 'provision',
  SYNCHRONIZE = 'synchronize',
}

export interface DirectConnectTask<T = any> {
  serialNumber: string;
  taskType: DirectConnectTaskType;
  payload: T;
}

export interface DirectConnectRegistrationResponse {
  id: string;
  expiration: number;
}

export interface DirectConnectHealthStatus {
  /**
   * Has the machine been registered?
   */
  isRegistered: boolean;

  /**
   * Serial number as read from the robot configuration files.
   */
  serialNumber: string;

  /**
   * Network health information.
   */
  network: DirectConnectHealthNetworkInfo;

  /**
   * If the machine is provisioned and synced then
   * we can return some machine context.
   * This helps the Beacon client to make API calls after
   * transitioning to the machine's WiFi.
   */
  machine?: DirectConnectHealthMachineInfo;

  /**
   * If the machine is provisioned and synced then
   * we can return some tenant context.
   */
  tenant?: DirectConnecHealthTenantInfo;

  /**
   * If the machine is provisioned and synced then
   * we can return just enough user context for the
   * Beacon client to show a log in screen.
   */
  users?: Array<DirectConnectHealthUserInfo>;
}

export interface DirectConnecHealthTenantInfo {
  tenantId: string;
  tenantName: string;
}

export interface DirectConnectHealthMachineInfo {
  tenantId: string;
  teamId: string;
  machineId: string;
  machineName: string;
  connectionType: MachineConnectionType;
}

export interface DirectConnectHealthUserInfo {
  userId: string;
  name: string;
  role: TeamRole;
  active: boolean;
  hasPinCode: boolean;
}

export interface DirectConnectHealthNetworkInfo {
  /**
   * Are we currently connected to AWS IoT?
   */
  isConnectedToCloud: boolean;

  /**
   * Can we reach the IoT domain?
   */
  isIotAccessible: boolean;

  /**
   * can we reach the API domain?
   */
  isApiAccessible: boolean;
}
